import Vue from 'vue'
import Router from 'vue-router'

// Container
import Container from '@/views/_layout/Container'
import Login from '@/views/_layout/Login'
import Empty from '@/views/_layout/Empty'

// Modules
import Dashboard from '@/views/dashboard/Dashboard'

Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Container,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'user',
          name: 'User',
          component: () => import('@/views/user/Index')
        },
        {
          path: 'duty',
          name: 'Duty',
          component: () => import('@/views/duty/Index')
        },
        {
          path: 'dutySearchMutil',
          name: 'DutySearchMutil',
          component: () => import('@/views/duty/Index')
        },
        {
          path: 'notDutyFile',
          name: 'NotDutyFile',
          component: () => import('@/views/duty/NotDutyFile')
        },
        {
          path: 'goodscc-:source',
          name: 'Goodscc',
          component: () => import('@/views/goodscc/Index')
        },
        {
          path: 'goodscc/clearanceRecordListUpload',
          name: 'ClearanceRecordListUpload',
          component: () => import('@/views/goodscc/ClearanceRecordListUpload')
        },
        {
          path: 'goodscc/clearanceRecordListDownload',
          name: 'ClearanceRecordListDownload',
          component: () => import('@/views/goodscc/ClearanceRecordListDownload')
        },
        {
          path: 'report-:source',
          name: 'Report',
          component: () => import('@/views/report/Index')
        },
        {
          path: 'tradevan/validate',
          name: 'TradevanValidate',
          component: () => import('@/views/tradevan/Validate')
        },
        {
          path: 'accountSettings',
          name: 'AccountSettings',
          component: () => import('@/views/accountSettings/Index')
        },
        {
          path: 'report/declFileList',
          name: 'ReportDeclFileList',
          component: () => import('@/views/report/DeclFileList')
        },
        {
          path: 'brokerReply',
          name: 'BrokerReply',
          component: () => import('@/views/brokerReply/BrokerReply')
        },
        {
          path: 'probTags',
          name: 'ProbTags',
          component: () => import('@/views/probTags/ProbTags')
        },
        {
          path: 'papers/papers',
          name: 'PapersPapers',
          component: () => import('@/views/papers/Papers')
        },
        {
          path: 'papers/g1List',
          name: 'PapersG1List',
          component: () => import('@/views/papers/G1List')
        },
        {
          path: 'papers/ptytkits',
          name: 'PapersPtytkits',
          component: () => import('@/views/papers/Ptytkits')
        },
        {
          path: 'delivery',
          name: 'Delivery',
          component: () => import('@/views/delivery/Delivery')
        },
        {
          path: 'jyb/parcel',
          name: 'JybParcel',
          component: () => import('@/views/jyb/Parcel')
        },
        {
          path: 'jyb/subtnoSelfDelivery',
          name: 'JybSubtnoSelfDelivery',
          component: () => import('@/views/jyb/SubtnoSelfDelivery')
        },
        {
          path: 'jyb/subtnoSea',
          name: 'JybSubtnoSea',
          component: () => import('@/views/jyb/SubtnoSea')
        },
        {
          path: 'jyb/pushnsPreApntd',
          name: 'JybPushnsPreApntd',
          component: () => import('@/views/jyb/PushnsPreApntd')
        },
        {
          path: 'jyb/pushnsTvUnverified',
          name: 'JybPushnsTvUnverified',
          component: () => import('@/views/jyb/PushnsTvUnverified')
        },
        {
          path: 'ccfile',
          name: 'Ccfile',
          component: () => import('@/views/ccfile/Ccfile.vue')
        },
        {
          path: 'auth/preApntd',
          name: 'AuthPreApntd',
          component: () => import('@/views/auth/PreApntd.vue')
        },
        {
          path: 'supplementTariff',
          name: 'SupplementTariff',
          component: () => import('@/views/supplementTariff/Index')
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        noAuth: true,
      }
    },
    {
      path: '/empty',
      name: 'Empty',
      component: Empty,
      meta: {
        noAuth: true,
      }
    }
  ]
})

// 统一处理地址栏参数
router.beforeEach((to, from, next) => {
  let accessToken

  // 通过地址栏传递了 accessToken
  if (to.query.accessToken && to.query.accessToken.length > 64) {
    accessToken = to.query.accessToken
    localStorage.setItem('accessToken', accessToken)
  } else {
    accessToken = localStorage.getItem('accessToken')
  }

  // 是否登录
  let isLogined = accessToken && accessToken.length > 64

  if (to.meta.noAuth) {
    // 不需要登录的页面
    next()
  } else {
    // 不在登录页面
    if (isLogined) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js